/*
 * Application shell
 */

import React from 'react';
import { ApolloProvider } from '@apollo/react-hooks';
// context providers
import { GeometryStateProvider } from 'src/@app/providers/GeometryProvider';
import { WindowDimensionsProvider } from 'src/utils';
// add icons
import { addIcons } from '@ems/client-design-system';
// appends icons to dom
addIcons();
// Enable FocusStyleManager by default
import { FocusStyleManager } from '@blueprintjs/core';
FocusStyleManager.onlyShowFocusOnTabs();
import { PageRouter } from 'src/@app/components';

// App component consumes multiple contexts
export const App = ({ client }) => {
  return (
    <WindowDimensionsProvider>
      <ApolloProvider client={client}>
        <GeometryStateProvider>
          <PageRouter />
        </GeometryStateProvider>
      </ApolloProvider>
    </WindowDimensionsProvider>
  );
};
